import React from 'react';

import { type IClientContextAction } from '@client/lib/ClientContext';
import { setCookie } from '@client/lib/Cookie';
import { getWebApp } from '@client/lib/Telegram';
import { CookieKey } from '@const/index';
import { setLang, type Lang } from '@lib/i18n';

export const updateLang = (value: string, dispatchContext: React.Dispatch<IClientContextAction>) => {
    const lang = value as Lang;

    setCookie(CookieKey.LANGUAGE, lang, 180);

    if (getWebApp().initData) {
        getWebApp().CloudStorage.setItem('lang', lang);
    }

    setLang(lang);
    dispatchContext({ event: 'set_language', lang });
};
